/** @typedef {{ slug?: string, toolkitSlug?: string, title?: string, icon?: string, iconUrl?: string, description?: string }} ConnectAppContext */

export const CONNECT_LEAD_SUB =
  'It will be saved to your account for easy use in other agents.'

const DEFAULT_CARD_DESCRIPTION =
  'This connection lets Sia use your account data when you ask for help with related tasks.'

/** Default bullets shown after the user completes the connect dialog (single source for block + UI). */

export const DEFAULT_CONNECT_SUCCESS_BULLETS = [
  'Read and search — browse threads, messages, and folders where supported.',
  'Send and draft — compose messages when you ask.',
  'Organize — labels, folders, and attachments where the app allows.',
]

export const DEFAULT_CONNECT_SUCCESS_CLOSING = 'What would you like help with next?'

/**
 * Detects the interim "Connect …" user prompt that should receive the structured assistant reply.
 *
 * @param {string} trimmed
 * @returns {boolean}
 */

export function isConnectAppUserMessage(trimmed) {
  return /^connect\s+\S/i.test(trimmed)
}

/**
 * @param {string} trimmed
 * @param {ConnectAppContext | null | undefined} connectContext
 * @returns {{ title: string, iconUrl: string | null, description: string }}
 */

export function resolveConnectAppDetails(trimmed, connectContext) {
  const fromPrompt = trimmed.replace(/^connect\s+/i, '').trim()
  const title =
    (connectContext?.title && String(connectContext.title).trim()) || fromPrompt || 'App'
  const iconUrl =
    (typeof connectContext?.icon === 'string' && connectContext.icon.trim()) ||
    (typeof connectContext?.iconUrl === 'string' && connectContext.iconUrl.trim()) ||
    null
  const description =
    (connectContext?.description && String(connectContext.description).trim()) ||
    DEFAULT_CARD_DESCRIPTION
  return { title, iconUrl, description }
}

/**
 * @param {{ title: string, iconUrl: string | null, description: string, toolkitSlug?: string | null }} details
 * @returns {Array<Record<string, unknown>>}
 */
